export default {
    'Menu': 'منو'
};
